import $ from 'jquery';

const cookieCAID = function () {

	const COOKIE_CAID = "CAID";
	const COOKIE_CAIDNEW = "CAID";

    function existsCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        return (parts.length == 2) ? true : false;
    }


    // Function to get a cookie
    function getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        return (parts.length == 2) ? parts.pop().split(";").shift() : "";
    }
	

	function setCookie(pValue, pDateExp) {

		/* Valeur au format cms : cms_$randomNumber10_$timestampExpiration
		  - $timestampExpiration basé sur la date d'expiration du cookie (13 mois à partir de sa création) yyyymmddhhmmss ?	*/
	
		// h+13mois ( + 13 * 30 * 24 * 60 * 60 * 1000 en millisecondes)
		let dateExpires = pDateExp; 
		if (dateExpires == null) {
			dateExpires = new Date();
			dateExpires.setMonth(dateExpires.getMonth() + 1); //si 12 (déc. +1) il passe au premier mois de l'année suivante
			dateExpires.setFullYear(dateExpires.getFullYear() + 1);				
		}		
		
		var value = pValue;
		// Create new value
		if (value == "") {
			// Nombre aléatoires sur 10 caractères
			let randomNumbers = Array.from({ length: 10 }, () => Math.floor(Math.random() * 10)).join(""); 
			let dateExpire = pad(dateExpires.getFullYear(),4) + pad(dateExpires.getMonth()+1,2) + pad(dateExpires.getDate(),2) + pad(dateExpires.getHours(),2) + pad(dateExpires.getMinutes(),2) + pad(dateExpires.getSeconds(),2);
			value = "cms_"+randomNumbers+"_"+dateExpire;
		}	
		
		let attributes = "; expires="+dateExpires.toUTCString()+"; SameSite=None; Secure; path=/; domain="+currentDomain();
		document.cookie = COOKIE_CAIDNEW+"="+value+attributes;
	}

	function currentDomain() {
		let domain=".sg.fr";
		if (location.href.indexOf(".socgen")>0) 
			domain = (location.href.indexOf(".bad.socgen")>0) ? ".bad.socgen" : ".si.socgen";
		return domain;
	}
	
	function pad(num, size) {
		let s = "000000000" + num;
		return s.substr(s.length - size);
	}
	
	function strToDate(strDate="") {
		return new Date(Number.parseInt(strDate.substr(0,4)), Number.parseInt(strDate.substr(4,2))-1, Number.parseInt(strDate.substr(6,2)), Number.parseInt(strDate.substr(8,2)), Number.parseInt(strDate.substr(10,2)), Number.parseInt(strDate.substr(12,2)) );
	}
	
    var cookieCAID = getCookie(COOKIE_CAID);
    let cookieCAID_TMP = existsCookie("CAID_TMP");
    var cookieCAIDNEW = getCookie(COOKIE_CAIDNEW);
	var cookietype  = "";
	var cookievalue = "";
	
	// Cookie old
    if (!((cookieCAID == null) || (cookieCAID == "")) ) {
		cookietype  = "old";
		cookievalue = cookieCAID;
	}
	
	/* Version avec cookie CAID1
    if ( !((cookieCAID1 == null) || (cookieCAID1 == "")) ) { cookietype = (cookieCAID1.startsWith("cms_")) ? "cms" : "new";	cookievalue = cookieCAID1; }*/
	
	// Version avec nouveau cookie cms qui s'appelle aussi CAID
    if (!((cookieCAID == null) || (cookieCAID == "")) ) {
		if (cookievalue.indexOf("_")>0) {
			cookietype = "new";
			if (cookieCAID.startsWith("cms_"))
				cookietype="cms";
		}
	}
	
	// RGs
	//- Si cookie CAID au format TMS (evt indiqué par cookie CAID_TMP) : mettre CAID au nouveau format et supprimer CAID_TMP
	//- Si cookie périmé ou inexistant : créer une nouvelle
	var dateExp = null;
	var hasexpired = false;

	// If old cookie : add 13 months to datevalue
	if (cookietype == "old") {
		if (cookievalue.length > 13) {
			dateExp = strToDate(cookievalue.substr(0,14));
			dateExp.setMonth(dateExp.getMonth() + 1);
			dateExp.setFullYear(dateExp.getFullYear() + 1);		
		}
	}
	
	// If new cookie get expiration date (last 14 caracters)
	// Si pas de date récupéré : indiquer que cookie a expiré afin de générer un nouveau cookie.
	if ( (cookietype=="new") || (cookietype=="cms") ) {
		if ( cookievalue.length > 13 )
			dateExp = strToDate(cookievalue.substr(cookievalue.length-14));
		else
			hasExpired = true;
	}

	// Check if cookie has expired
	// Si expiré : effacer la date, ainsi la date d'aujourd'hui + 13 mois sera enregistré
	// Sinon garder la date d'expiration en cours
	if (dateExp != null) {
		let today = new Date();
		if ( today.getTime() >= dateExp.getTime() ) {
			hasexpired = true;
			dateExp = null; 
		}	 
	}

	// if cookie CAID_TMP : reprendre valeur cookie mais modifier le timestamp
    if (cookieCAID_TMP) {
		setCookie(cookievalue, dateExp);
		// delete cookie
        document.cookie = "CAID_TMP=; path=/; domain="+currentDomain()+"; expires=Thu, 01 Jan 1970 00:00:01 GMT";
	}
	
	// Si cookie expiré, ou pas de cookie du tout : créer nouveau cookie cms
	if ( (hasexpired==true) || (cookietype=="") ) {
		setCookie("", dateExp);
	}

};

export {cookieCAID};


// WEBPACK FOOTER //
// ./src/js/cms/commons/cookieCAID.js